const OPENABLE_BATCH_STATUSES = new Set(["DRAFT", "SIMULATED"]);
const SIMULATABLE_LINE_STATUSES = new Set(["VALID", "PENDING"]);

/**
 * « Simuler » est proposé quand le lot est encore ouvrable.
 *
 * Détail (`GET /PayrollBatches/{id}`, lignes présentes) : même règle que
 * la fiche — statut `DRAFT` ou `SIMULATED`, et au moins une ligne `VALID`
 * ou `PENDING`. `PENDING` suffit : `VALID` n'existe qu'après simulation.
 *
 * Liste (`POST /PayrollBatches/all`) : le DTO de ligne n'embarque pas
 * `lines`. On masque l'action dès que le statut montre que simuler est
 * impossible (`PROCESSING`, `COMPLETED`, `PARTIALLY_COMPLETED`, `FAILED`,
 * `CANCELLED`) ou que le lot est vide (`lineCount` à 0, 422 « paie vide »).
 * Sinon le menu ouvre la preview ; le serveur répond 422 si aucune ligne
 * n'est simulable. Pas de drapeau `canSimulate` dans la collection v4.1.
 */
export function canSimulatePayrollBatch(batch: {
  status?: string | null;
  lineCount?: number | null;
  lines?: readonly { status?: string | null }[] | null;
}): boolean {
  const status = (batch.status ?? "").trim().toUpperCase();
  if (!OPENABLE_BATCH_STATUSES.has(status)) return false;

  if (batch.lines != null && batch.lines.length > 0) {
    return batch.lines.some((line) =>
      SIMULATABLE_LINE_STATUSES.has((line.status ?? "").trim().toUpperCase())
    );
  }

  if (typeof batch.lineCount === "number") return batch.lineCount > 0;
  return true;
}
